const languageObj = {
  "Video Compressor": "ضاغط للفيديو",
  "HitPaw Online Video Compressor": "ضاغط الفيديو عبر الإنترنت HitPaw",
  "Best video compressor tool to reduce video file size online without losing quality.": "أفضل أداة لضغط الفيديو لتقليل حجم ملف الفيديو عبر الإنترنت دون فقدان الجودة.",
  "Quality": "جودة",
  "Small Size": "حجم صغير ({{num}}٪)",
  "High Quality": "جودة عالية ({{num}}٪)",
  "Frame Rate": "معدل الإطار",
  "Resolution": "الدقة",
  "Keep Resolution": "احتفظ بالدقة الأصلية",
  "Format": "تنسيق",
  "Compress": "ضغط",
  "Compressing": "جاري الضغط",
  "Compress New": "ضغط جديد",
  "xx% reduction in size!": "تخفيض في الحجم {{num}}%!",
  "Compressed successfully, your file is now xxMB.": "ضغط بنجاح، ملفك الآن <p> {{originalSize}}</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "فشل الضغط",
};

export default languageObj